const smoothScroll = (() => {
  const smoothScrollTrigger = document.querySelectorAll(
    'a[href^="./#"], a[href^="#"]'
  );
  smoothScrollTrigger.forEach((t) => {
    t.addEventListener("click", (e) => {
      e.preventDefault();
      let href = t.getAttribute("href");
      let element;
      if (href !== null) {
        element = document.getElementById(href.replace("#", ""));
      }
      let headerOffset: number = 20;
      const elementPosition = element?.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    });
  });
})();

const setFillHeight = (() => {
  const setFillHeightProperty = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  let vw = window.innerWidth;

  window.addEventListener("resize", () => {
    if (vw === window.innerWidth) {
      // 画面の横幅にサイズ変動がないので処理を終える
      return;
    }

    // 画面の横幅のサイズ変動があった時のみ高さを再計算する
    vw = window.innerWidth;
    setFillHeightProperty();
  });

  // 初期化
  setFillHeightProperty();
})();

const setFillWidth = () => {
  const clientWidth = document.body.clientWidth; // スクロールバーを除いた幅を取得
  document.documentElement.style.setProperty("--vw", clientWidth + "px");

  let timer: NodeJS.Timeout | undefined;

  window.addEventListener("resize", () => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      setFillWidth();
    }, 200);
  });
};
setFillWidth();

// ヘッダーのbutton要素にハンバーガーメニューのバーを追加する
const addBarMenuButton = (() => {
  const menuButtonElement = document.querySelectorAll(
    ".site-header .wp-block-navigation__responsive-container-open"
  );
  Array.from(menuButtonElement).forEach((e) => {
    for (let i = 1; i <= 3; i++) {
      const spanElement = document.createElement("span");
      spanElement.className = "menu-bar";
      e.appendChild(spanElement);
    }
  });
})();

const hoverHeaderMenu = (() => {
  if (window.matchMedia("(max-width: 599px)").matches) {
    return;
  } else {
    const liElements = document.querySelectorAll(
      ".wp-block-navigation__container > li"
    );

    liElements.forEach((li) => {
      li.addEventListener("mouseenter", () => {
        const hasChildClass = li.classList.contains("has-child");

        // マウスオーバーされたli要素以外のli要素の不透明度を0.3にする
        liElements.forEach((otherLi) => {
          if (otherLi !== li) {
            (otherLi as HTMLElement).style.opacity = "0.3";
          }
        });

        if (hasChildClass) {
          const submenuContainer = li.querySelector(
            ".wp-block-navigation__submenu-container"
          );
          if (submenuContainer) {
            (submenuContainer as HTMLElement).style.opacity = "1";
            (submenuContainer as HTMLElement).style.height = "3.125rem";
          }
        }
      });

      li.addEventListener("mouseleave", () => {
        liElements.forEach((otherLi) => {
          if (otherLi !== li) {
            (otherLi as HTMLElement).style.opacity = "1";
          }
        });

        // submenuContainerの高さをリセット
        const submenuContainer = li.querySelector(
          ".wp-block-navigation__submenu-container"
        );
        if (submenuContainer) {
          (submenuContainer as HTMLElement).style.height = "0";
        }
      });
    });

    // サブメニュー
    const subLiElements = document.querySelectorAll(
      ".wp-block-navigation__submenu-container.wp-block-navigation-submenu li"
    );

    subLiElements.forEach((li) => {
      li.addEventListener("mouseenter", () => {
        // マウスオーバーされたli要素以外のli要素の不透明度を0.3にする
        subLiElements.forEach((otherLi) => {
          if (otherLi !== li) {
            (otherLi as HTMLElement).style.opacity = "0.3";
          }
        });
      });

      li.addEventListener("mouseleave", () => {
        subLiElements.forEach((otherLi) => {
          if (otherLi !== li) {
            (otherLi as HTMLElement).style.opacity = "1";
          }
        });
      });
    });
  }
})();
